const HIDDEN_ROOM_STATES = new Set([
  'pending',
  'open',
  'waiting',
  'declined',
  'accepted_not_selected',
  'lost',
  'cancelled',
  'director_removed',
])

export function isSubstitutionRoomVisible(
  lesson: {
    status?: string | null
    assignment_state?: string | null
    assigned_teacher_id?: string | null
  },
  perspective: 'viewer' | 'owner' | 'admin' = 'viewer',
  myTeacherId?: string | null,
): boolean {
  const state = lesson.assignment_state || ''
  const status = lesson.status || ''
  if (HIDDEN_ROOM_STATES.has(state) || HIDDEN_ROOM_STATES.has(status)) return false
  const firm = state === 'confirmed' || state === 'booked' || status === 'confirmed' || status === 'booked'
  if (perspective === 'admin') {
    const accepted = state === 'accepted' || status === 'accepted'
    return !!lesson.assigned_teacher_id && (firm || accepted)
  }
  if (perspective === 'owner') return firm
  if (
    lesson.assigned_teacher_id
    && myTeacherId
    && lesson.assigned_teacher_id !== myTeacherId
  ) {
    return false
  }
  return firm
}

export function substitutionRoomLabel(
  lesson: {
    status?: string | null
    assignment_state?: string | null
    assigned_teacher_id?: string | null
    room_name?: string | null
  },
  perspective: 'viewer' | 'owner' | 'admin' = 'viewer',
  myTeacherId?: string | null,
): string | null {
  if (!isSubstitutionRoomVisible(lesson, perspective, myTeacherId)) return null
  const name = lesson.room_name?.trim()
  if (!name || name === '-' || name === '—') return null
  return `Raum ${name}`
}
